let myAccountMenu = document.getElementById('utility-my-account-menu');
let myAccountLink = document.getElementById('utility-nav-my-account-link');

const OPEN_CLASS = "open";

export function myAccountMenuApp() {
    if (myAccountLink) {
        myAccountLink.addEventListener('click', toggleMyAccountMenu);
    }
    if (myAccountMenu) {
        document.addEventListener('click', (e) => closeMyAccountMenu(e));
    }    

}

function toggleMyAccountMenu() {
    if (myAccountMenu) {
        if (myAccountMenu.classList.contains(OPEN_CLASS)) {
            myAccountMenu.classList.remove(OPEN_CLASS);            
        }
        else {
            myAccountMenu.classList.add(OPEN_CLASS);
        }
    }

    if (myAccountLink) {
        if (myAccountLink.classList.contains(OPEN_CLASS)) {
            myAccountLink.classList.remove(OPEN_CLASS);            
        }
        else {
            myAccountLink.classList.add(OPEN_CLASS);
        }
    }
}

function closeMyAccountMenu(e) {
    if (myAccountMenu && myAccountMenu.classList.contains(OPEN_CLASS) && !myAccountMenu.parentNode.contains(e.target)) {
        myAccountMenu.classList.remove(OPEN_CLASS);
        myAccountLink.classList.remove(OPEN_CLASS);
    }
}